// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.label[data-v-3e11c6c8] {\r\n  font-size: 11px;\r\n  color: #828282;\n}\n.value[data-v-3e11c6c8] {\r\n  font-size: 13px;\r\n  font-weight: 500;\n}\r\n", ""]);
// Exports
module.exports = exports;
